import React from 'react'
import { useNavigate } from 'react-router-dom'
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import { OrdersContext } from 'contexts/OrdersContext'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  PixelCurrency,
  PixelDate,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelText,
  Section,
  SectionContent,
} from 'pixel-base'
import { getBankAccounts, getDarazStatements } from 'utils/api-routes.util'

import CreateReceivedPayment from './components/CreateReceivedPayment'
import { IPixelFactory } from '../../../../decl.d'

const breadcrumbs = [
  {
    name: 'Daraz Statements',
    active: true,
  },
]
const DarazStatements = () => {
  const navigate = useNavigate()
  const { state } = React.useContext(OrdersContext)
  const [darazStatements, setDarazStatements] = React.useState([])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [couriers, setCouriers] = React.useState<IAllowedCourier>([])
  const [bankAccounts, setBankAccounts] = React.useState([])
  const [payment, setPayment] = React.useState({})
  const { showSuccess } = React.useContext<IPixelFactory>(PixelFactoryContext)
  React.useEffect(() => {
    setCouriers(state?.couriers)
  }, [state?.couriers])

  const getAllDarazStatements = () => {
    setTableLoading(true)
    getDarazStatements().subscribe((res: any) => {
      const statements = res.response.data?.map((item) => {
        item.payout = Number(item.payout.replace(' PKR', ''))
        return item
      })
      setDarazStatements(statements)
      setTableLoading(false)
    })
  }
  const getAllBankAccounts = () => {
    getBankAccounts().subscribe((res) => {
      setBankAccounts(res.response.data)
    })
  }
  const onRowClicked = (row) =>
    navigate(`/payments/details?statement_number=${row.statement_number}`)
  React.useEffect(() => {
    getAllDarazStatements()
    getAllBankAccounts()
  }, [])
  const columns = [
    {
      dataKey: 'statement_number',
      name: 'Statement Name',
      sortable: true,
      width: '25%',
      selector: (row) => <PixelText>{row.statement_number}</PixelText>,
    },
    {
      dataKey: 'created_at',
      name: <PixelText>Create Date</PixelText>,
      sortable: true,
      width: '14%',
      selector: (row) => (
        <PixelDate format="pixelStandard" value={row.created_at} />
      ),
    },
    {
      dataKey: 'fees_total',
      name: <PixelText>Total Fee</PixelText>,
      sortable: true,
      selector: (row) => <PixelCurrency hideSymbol value={row.fees_total} />,
    },
    {
      dataKey: 'refunds',
      name: 'Refunds',
      sortable: true,
      selector: (row) => row.refunds || '--',
    },
    {
      dataKey: 'payout',
      name: 'Payout',
      sortable: true,
      selector: (row) => row.payout || '--',
    },
    {
      dataKey: 'paid',
      name: 'Paid',
      sortable: true,
      selector: (row) => (
        <PixelIcon
          color={row.paid == 1 ? 'green' : 'red'}
          icon={row.paid == 1 ? faCheck : faXmark}
        />
      ),
    },
    {
      dataKey: 'actions',
      name: <PixelText>Payment Verification</PixelText>,
      selector: (row) => (
        <PixelFlexBox
          onClick={() => {
            setPayment(row)
            if (!row.payment_id) setShowNewModal(true)
          }}
        >
          <DcButton
            size="sm"
            disabled={row.payout == 0 ? true : row.payment_id}
            variant={
              row.payout == 0
                ? 'secondary'
                : row.payment_id
                ? 'secondary'
                : 'primary'
            }
          >
            {row.payout == 0
              ? 'Verified'
              : row.payment_id
              ? 'Verified'
              : 'Verify'}
          </DcButton>
        </PixelFlexBox>
      ),
    },
  ]
  return (
    <>
      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="60px"
              fontSize="16px"
              style={{ fontSize: '16px', padding: '8px 0px' }}
            >
              <DcFlexBox
                justifyContent="space-between"
                alignItems="center"
                padding=".5rem 20px"
              >
                <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

                <ProfileSection />
              </DcFlexBox>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={darazStatements}
              progressPending={tableLoading}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 180px)"
              highlightOnHover={true}
              pointerOnHover={true}
              onRowClicked={onRowClicked}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <PixelModal
        show={showNewModal}
        handleClose={() => {
          setShowNewModal(false)
        }}
        size={'lg'}
        title={'Verify Daraz Payment in Bank Account'}
      >
        <CreateReceivedPayment
          couriers={couriers}
          paymentData={payment}
          paymentCourier={'Daraz'}
          handleClose={(data) => {
            if (data) {
              setDarazStatements(
                darazStatements.map((item) => {
                  if (item.statement_number == data.invoice_reference) {
                    item.payment_id = data.courier_payment_id
                  }
                  return item
                }),
              )
            }
            setShowNewModal(false)
            showSuccess('Payment Verified Successfully')
          }}
          bankAccounts={bankAccounts}
        />
      </PixelModal>
    </>
  )
}
export default DarazStatements
